export const friquet = (program, classProgram) => {
  if (program) {
    switch (true) {
      case program.value === "פעילות סוכות": {
        return [{ value: 0, label: "חד פעמי" }];
      }
      case program.value === "היפ-הופ": {
        return [
          { value: 1, label: "רגיל" },
          { value: 2, label: "תחרותי" },
          { value: 3, label: "נשים" },
        ];
      }
      case program.value === "סטודיו מיתרים": {
        if (
          classProgram.label === "פרטני בתיאום אישי") {
          return [
            { value: 1, label: "30 דק׳" },
          ];
        } else if (classProgram.label === "גילאי 7-18") {
          return [{ value: 1, label: "45 דק׳" }];
        } else {
          return [
            { value: 1, label: "30 דק׳" },
          ];
        }
      }
      case program.value === "כדוריד": {
        return [
          { value: 1, label: "פעם בשבוע" },
          { value: 2, label: "פעמיים בשבוע" },
        ];
      }
      case program.value === "כדורעף": {
        return [
          { value: 1, label: "פעם בשבוע" },
          { value: 2, label: "פעמיים בשבוע" },
        ];
      }
      case program.value === "ג׳ודו": {
        return [
          { value: 1, label: "45 דק" },
          { value: 2, label: "60 דק" },
          { value: 3, label: "פעמיים בשבוע" },
        ];
      }
      case program.value === "חוג מחשבים קייטנת חנוכה": {
        return [
          { value: 0, label: "תשלום אחד" }
        ]
      }
      case program.value === "טאקוונדו": {
        return [{ value: 1, label: "פעם בשבוע" }];
      }
      case program.value === "כדור יד" ||
        program.value === "טריקינג" ||
        program.value === "קרב מגע לילדים":
        return [{ value: 1, label: "פעם בשבוע" }];
      case program.value === "מצויינות בספורט":
        return [{ value: 1, label: "פעמיים בשבוע" }];
      case program.value.includes("מצוינות בספורט עולים"):
        return [{ value: 1, label: "חד פעמי" }];
      case program.value === "מצויינות קרקע ומכשירים":
        return [{ value: 1, label: "חודשי" }];
      //only twice cases!
      case program.value === "צהרון 2023-2024":
        return [{ value: 1, label: "יומי" }];
      case program.value === "תשלומי עמותה" ||
        program.value === "דמי רישום מצויינות בספורט":
        return [{ value: 1, label: "חד פעמי" }];
      case program.value === "צהרון קיץ":
        return [{ value: 1, label: "חד פעמי" }];
      default:
        return [{ value: 1, label: "פעם בשבוע" }];
    }
  } else {
    return "";
  }
};
